import { render } from "./ProductItem.vue?vue&type=template&id=41e44882&scoped=true&ts=true"
import script from "./ProductItem.vue?vue&type=script&lang=ts"
export * from "./ProductItem.vue?vue&type=script&lang=ts"

import "./ProductItem.vue?vue&type=style&index=0&id=41e44882&lang=postcss&scope=true"
import "./ProductItem.vue?vue&type=style&index=1&id=41e44882&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41e44882"]])

export default __exports__